<template>
  <form-item-wrapper
    :designer="designer"
    :field="field"
    :rules="rules"
    :design-state="designState"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex"
    :sub-form-col-index="subFormColIndex"
    :sub-form-row-id="subFormRowId"
  >
    <el-button
      ref="fieldEditor"
      :type="field.options.type"
      :size="field.options.size"
      :class="[field.options.label === '' ? 'hide-text-span' : '']"
      :plain="field.options.plain"
      :round="field.options.round"
      :circle="field.options.circle"
      :icon="field.options.icon"
      :disabled="field.options.disabled"
      @click.native="open()"
      >{{ field.options.title }}</el-button
    >
    
    <jf-post ref="JfPost" :max-num="field.options.maxNum" :value="fieldModel?fieldModel:[]" @input="onConfirm"></jf-post>
  </form-item-wrapper>
</template>
<script>
import FormItemWrapper from "./form-item-wrapper";
import emitter from "@/vform/utils/emitter";
import i18n, { translate } from "@/vform/utils/i18n";
import fieldMixin from "@/vform/components/form-designer/form-widget/field-widget/fieldMixin";
import JfPost from "@/components/jf-post/jf-post";

export default {
  model: {
    prop: "value",
    event: "input",
  },
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  name: "post-select-widget",
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  components: {
    FormItemWrapper,
    JfPost,
  },
  inject: ["refList", "globalOptionData", "globalModel"],
  data() {
    return {
      fieldModel: null,
      tabList: ["post"],
      dialogVisible: false,
      rules: [],
    };
  },
  watch: {},

  methods: {
    open() {
      this.$refs["JfPost"].open();
    },
    onConfirm(e) {
    //   let data = { post: e };
      this.fieldModel = e;
      this.handleChangeEvent(JSON.stringify(e));
    },
  
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  height: 70vh;
  overflow: auto;
}
.width-100 {
  width: 100%;
}
.box-card .post-tags {
  height: 185px;
  overflow-y: auto;
  .tips {
    // font-size: 12px;
    text-align: center;
    color: #909399;
  }
}
.post-tags {
  // display: flex;
  // flex-wrap: wrap;
  margin: -5px;

  .post-tag {
    margin: 5px !important;
  }
}
</style>
<style lang="stylus" scoped>
.tags {
    .input-box.as-input {
        border: 1px solid #DCDFE6;
        padding-left: 6px;
        font-size: 12px;
        min-height: 32px;
        line-height: 30px;
        border-radius: 4px;
        background: white;
        color: #606266;
        cursor: pointer;
    }

    .org-tag {
        margin-right: 6px;
        max-width: 6rem;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        padding-right: 1rem;
        vertical-align: middle;

        >>> .el-tag__close {
            position: absolute;
            right: 2px;
            top: 50%;
            margin-top: -7px;
        }
    }
}
</style>
